/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  HeaderService,
  IHeaderMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  ILoadingMethods,
  LoadingService,
  IBatchSerializationListMethods,
  BatchSerializationListService,
} from './components';

export type CampaignListPageAgent = IHeaderMethods &
  IStaticPageContentMethods &
  ILoadingMethods &
  IBatchSerializationListMethods;

const getPlugins = () => {
  return [
    new HeaderService(),
    new BatchSerializationListService(),
    new StaticPageContentService(),
    new LoadingService(),
  ];
};

export const getAgent = () => {
  return createAgent<CampaignListPageAgent>({
    plugins: getPlugins(),
  });
};
